import cx from 'classnames';
import type React from 'react';
import Tooltip from './Tooltip';

type OwnProps = {
  content: React.ReactNode;
  eventTracker: any;
  isMobile?: boolean;
  light: boolean;
  tooltip: boolean;
};

export default function CTTooltip({
  tooltip,
  content,
  light,
  isMobile,
  eventTracker
}: OwnProps) {
  return (
    <div
      onMouseOver={eventTracker}
      onFocus={eventTracker}
      className={cx('ct-tooltip__wrapper', {
        light,
        visible: tooltip
      })}
    >
      <Tooltip
        component={content}
        right
        className={cx('ct-tooltip short', {
          mobile: isMobile
        })}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 5.00606C7 5.55152 7.44848 6 7.99394 6C8.53939 6 9 5.55152 9 5.00606C9 4.46061 8.53939 4 7.99394 4C7.44848 4 7 4.46061 7 5.00606ZM8 7C7.44772 7 7 7.44772 7 8V11C7 11.5523 7.44772 12 8 12C8.55229 12 9 11.5523 9 11V8C9 7.44772 8.55229 7 8 7Z"
            fill="currentColor"
          />
        </svg>
      </Tooltip>
    </div>
  );
}
